module.exports = __webpack_public_path__ + "static/Highways-UK-Winner.38aed81e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/WinterLanding/Highways-UK-Winner.jpg
// module id = 465
// module chunks = 35783957827783